export default __webpack_public_path__ + "img/checkout.hero.asset.b87803de.jpg";